<template>
  <div>
    <b-modal
      v-model="isModalActive"
      :width="250"
      trap-focus
      :destroy-on-hide="false"
      @close="handleClose"
    >
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Game Settings</p>
            <button type="button" class="delete" @click="closeModal" />
          </header>
          <section class="modal-card-body">
            <div class="is-flex is-flex-direction-column"></div>

            <b-field class="has-text-left">
              <b-checkbox v-model="showThreats" type="is-primary">
                Show threats
              </b-checkbox>
            </b-field>
            <b-field class="has-text-left">
              <b-checkbox v-model="premove" type="is-primary">
                Premove
              </b-checkbox>
            </b-field>
            <b-field class="has-text-left">
              <b-checkbox v-model="autoQueen" type="is-primary">
                Auto-queen
              </b-checkbox>
            </b-field>
            <b-field class="has-text-left">
              <b-checkbox v-model="showSpectators" type="is-primary">
                Show spectators
              </b-checkbox>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button label="Close" @click="closeModal" />
            <b-button label="Save" type="is-primary" @click="handleSave" />
          </footer>
        </div>
      </form>
    </b-modal>
    <b-tooltip label="Game Settings" type="is-primary">
      <b-button
        icon-left="user-cog"
        type="is-primary is-outlined"
        @click="isModalActive = true"
      />
    </b-tooltip>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

export default {
  name: "GameSettings",

  props: ["gameSettings"],

  data() {
    return {
      isModalActive: false,
      showThreats: null,
      premove: null,
      autoQueen: null,
      showSpectators: null,
    };
  },

  computed: {
    ...mapGetters(["getUserId"]),
  },

  watch: {
    gameSettings: {
      immediate: true,
      handler() {
        if (!this.gameSettings) return;
        this.setSettings();
      },
    },
  },

  methods: {
    handleSave() {
      firestore
        .collection("settings")
        .doc("" + this.getUserId)
        .set(
          {
            showThreats: this.showThreats,
            premove: this.premove,
            autoQueen: this.autoQueen,
            showSpectators: this.showSpectators,
          },
          { merge: true }
        )
        .then(this.closeModal);
    },

    handleClose() {
      this.setSettings();
    },

    setSettings() {
      this.showThreats = !!this.gameSettings.showThreats;
      this.premove = !!this.gameSettings.premove;
      this.autoQueen = !!this.gameSettings.autoQueen;
      this.showSpectators = !!this.gameSettings.showSpectators;
    },

    closeModal() {
      this.setSettings();
      this.isModalActive = false;
    },
  },
};
</script>

<style></style>
